import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-pop-up',
  templateUrl: './terms-pop-up.component.html',
  styleUrls: ['./terms-pop-up.component.scss']
})
export class TermsPopUpComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _dialogRef: MatDialogRef<TermsPopUpComponent>,) { }

  ngOnInit(): void {
  }
dialogClose(){
  // this._dialogRef.close();
  document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
  document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
  setTimeout(() => { this._dialogRef.close(); }, 1000);
}
}
